//* Importing base modules
import { useState } from "react";

//* Importing bootstrap components
import { InputGroup, Form } from "react-bootstrap"; 

//* Importing components
import { Input } from "reactstrap";

//! Importing APIs
import { AuthAPI } from "../../../services/apis/AuthAPI";

//* Importing components
import DefaultButton from "../../../component/base/DefaultButton";


type VerifyFormProps ={
  setCurrentStep: (step: string) => void;
  email: string;
  message: string;
  setMessage: (message: string) => void;
}

export function VerifyForm({
  setCurrentStep,
  email,
  message,
  setMessage,
}: VerifyFormProps) {
  const [code, setCode] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const verifyResetCode = async () => {
    setLoading(true);
    setMessage("");
    const response = await AuthAPI.verifyResetCode(email, code);
    if (response) {
      setCurrentStep("resetPassword");
    } else {
      setMessage(response.message);
    }
    setLoading(false);
  };

  return (
    <form
      className="form-horizontal m-t-30"
      onSubmit={(e) => {
        e.preventDefault();
        verifyResetCode();
      }}
    >
      <h4 style={{ fontSize: 18 }}>Verificar Código</h4>
      <p className="text-muted" style={{ fontSize: 14 }}>
        Insira o código enviado para o seu e-mail.
      </p>
      <InputGroup>
        <div className="flex fdcolumn flex1 margin-bottom">
          <Form.Label>Código</Form.Label>
          <Input
            type="text"
            style={{ fontSize: 14 }}
            placeholder="Código de verificação"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </div>
      </InputGroup>
      {message && <p style={{ color: "red", fontSize: "0.8rem" }}>{message}</p>}
      <DefaultButton
        type="submit"
        bg="primary"
        width="100%"
        height="3rem"
        style={{ marginTop: "15px" }}
        text="Verificar Código"
        loadingtext="Verificando..."
        loading={loading}
      />
      <div
        style={{
          marginTop: "15px",
          textAlign: "left",
        }}
      >
        <span
          style={{
            fontSize: "0.9rem",
            color: "#007bff",
            cursor: "pointer",
          }}
          onClick={() => setCurrentStep("enterEmail")}
        >
          Voltar
        </span>
      </div>
    </form>
  );
}
